import * as React from 'react';
import { SVGProps } from 'react';

const IconUnderlineSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.5 12c2.76 0 4.5-2.24 4.5-5V1h-2v6.5a2.5 2.5 0 0 1-5 0V1H4v6c0 2.76 1.74 5 4.5 5zM3 13v2h11v-2H3z" />
  </svg>
);
export default IconUnderlineSizeS;
